import { Fragment, useEffect, useState } from "react";
import {
  Grid,
  Button,
  ListItemButton,
  ListItemIcon,
  Typography,
  useTheme,
  Box,
  Paper,
  Card,
  Chip,
  IconButton,
  Divider,
  alpha,
} from "@mui/material";
import PersonPinCircleRoundedIcon from "@mui/icons-material/PersonPinCircleRounded";
import { ButtonCustom } from "../Botoes/Button";
import Titulo from "../Textos/Titulo";
import useAlert from "../../hooks/useAlert";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useQuery, useMutation, useQueryClient } from "react-query";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddLocationIcon from "@mui/icons-material/AddLocation";

import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";

import { EnderecoItem } from "../";
import { CLIENTEENDERECOS } from "../../util/typesReactQuery";
import useStyles from "./styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  desativaAtivaByID,
  saveEndereco,
  getEnderecos,
} from "../../api/Endereco";
import { useAuth } from "../../hooks/AuthContext";
import BasicModal from "../Modal/Modal";
import { ButtonAcaoGrande } from "../../components/index";

export default function ClienteEndereco({
  isSedex = false,
  setSelectedID,
  idCliente,
  isOperacao = false,
  isLoading = false,
  handlerNext,
  regiaoEntregaSelecionada = null,
  handlerChangeSedex,
  enderecoItemSelecionado,
  sedexSelecionado,
}) {
  const queryClient = useQueryClient();
  const { showAlertSuccess, showAlertError } = useAlert();
  const classes = useStyles();
  const { user } = useAuth();
  const enderecoDefault = {
    id: 0,
    idCliente: idCliente,
    cep: "",
    cidade: "",
    bairro: "",
    logradouro: "",
    numero: "",
    complemento: "",
    uf: "",
    idUf: 0,
    idTipoEndereco: 1,
  };
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);
  const [enderecoModal, setEnderecoModal] = useState();
  const [enderecoSelected, setEnderecoSelected] = useState();
  const [enderecoFiltro, setEnderecoFiltro] = useState([]);
  const [selectedEnderecoSedex, setSelectedEnderecoSedex] = useState(0);
  const [textError, setTextError] = useState("");
  const [textSuccess, setTextSuccess] = useState("");

  const mutationSaveEndereco = useMutation(saveEndereco, {
    onSuccess: (response) => {
      if (response.errorMessage && response.errorMessage.length > 0) {
        showAlertError(response.errorMessage);
      } else {
        showAlertSuccess("Oba! Seu endereço foi cadastrado com sucesso");
        setTimeout(() => {
          if (openModal) setOpenModal(false);
        }, 600);
      }
    },
    onError: async (err, variables, context) => {
      console.error(err);
      showAlertError(
        "Ahh, Algo deu errado, por favor informe ao suporte tecnico o seguinte erro - " +
          err
      );
    },
    onSettled: async () => {
      queryClient.invalidateQueries(CLIENTEENDERECOS);
    },
  });

  const mutationDesativa = useMutation(desativaAtivaByID, {
    onSuccess: (response) => {
      if (response.errorMessage && response.errorMessage.length > 0) {
        showAlertError(response.errorMessage);
      } else {
        showAlertSuccess("O status de seu endereço foi alterado");
      }
    },
    onError: async (err, variables, context) => {
      console.error(err);
      showAlertError(
        "Ahh, Algo deu errado, por favor informe ao suporte tecnico o seguinte erro - " +
          err
      );
    },
    onSettled: async () => {
      queryClient.invalidateQueries(CLIENTEENDERECOS);
    },
  });

  const handlerChangeEnderecoEntrega = (idEndereco) => () => {
    if (isOperacao) setSelectedID(idEndereco);
  };

  const handlerSubmitSalvarEndereco = async () => {
    try {
      mutationSaveEndereco.mutate(enderecoSelected);
    } catch (error) {
      showAlertError("Ops,algo deu errado: ", error.message);
    }
  };

  const handlerCloseModal = (e) => {
    setOpenModal(false);
  };

  const handlerEditarEndereco = (endereco) => (event) => {
    setEnderecoModal(endereco);
    setOpenModal(true);
  };

  const {
    data: enderecosCliente,
    isLoading: isLoadingEnderecosCliente,
    refetch: refetchEnderecosCliente,
  } = useQuery(CLIENTEENDERECOS, () => getEnderecos(idCliente), {
    refetchOnWindowFocus: false,
    enabled: true,
  });

  const desativaAtiva = (id) => (event) => {
    event.preventDefault();
    if (id < 0) {
      showAlertError(
        "Ahh! Infelizmente não conseguimos identificar o seu endereço, por gentileza tente mais tarde  - R2AD9"
      );
      return;
    }

    let enderecoSelecionado = {
      idCliente: user.id,
      idEndereco: id,
    };
    mutationDesativa.mutate(enderecoSelecionado);
  };

  const handlerSelectedSedex = (event, endereco) => {
    setSelectedEnderecoSedex(endereco.id);
  };

  const ListIsOperacao = ({ endereco }) => {
    const isSelected =
      enderecoItemSelecionado?.id === endereco?.id ||
      sedexSelecionado?.id === endereco.id;

    return (
      <Card
        elevation={isSelected ? 3 : 1}
        sx={{
          mb: 2,
          borderRadius: 2,
          border: isSelected
            ? `2px solid ${theme.palette.primary.main}`
            : `1px solid ${theme.palette.divider}`,
          transition: "all 0.2s ease",
          "&:hover": {
            boxShadow: 4,
            transform: "translateY(-1px)",
          },
        }}
      >
        <ListItemButton
          onClick={
            isSedex
              ? (event) => handlerChangeSedex(event, endereco)
              : (event) => handlerNext(event, endereco)
          }
          sx={{
            p: 2,
            display: "flex",
            alignItems: "flex-start",
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 40,
              color: isSelected ? theme.palette.primary.main : "inherit",
              mt: 0.5,
            }}
          >
            <HomeWorkIcon />
          </ListItemIcon>

          <Box sx={{ flex: 1, ml: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                mb: 1,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {endereco.cidade}
              </Typography>
              {isSelected ? (
                <CheckIcon
                  sx={{
                    color: theme.palette.primary.main,
                    fontSize: 20,
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    borderRadius: "50%",
                    p: 0.5,
                  }}
                />
              ) : (
                <ArrowForwardIosIcon
                  sx={{ color: theme.palette.text.secondary, fontSize: 16 }}
                />
              )}
            </Box>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 1 }}>
              <Chip
                label={`CEP: ${endereco.cep}`}
                size="small"
                variant="outlined"
                sx={{ fontSize: "0.75rem" }}
              />
              <Chip
                label={endereco.ufDescricao}
                size="small"
                color="primary"
                variant="filled"
                sx={{ fontSize: "0.75rem" }}
              />
            </Box>

            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <Box component="span" sx={{ fontWeight: 600 }}>
                Endereço:{" "}
              </Box>
              {endereco.logradouro} {endereco.numero && `, ${endereco.numero}`}
            </Typography>

            <Typography variant="body2" sx={{ mb: 0.5 }}>
              <Box component="span" sx={{ fontWeight: 600 }}>
                Bairro:{" "}
              </Box>
              {endereco.bairro}
            </Typography>

            {endereco.complemento && (
              <Typography variant="body2" sx={{ fontStyle: "italic" }}>
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Complemento:{" "}
                </Box>
                {endereco.complemento}
              </Typography>
            )}
          </Box>
        </ListItemButton>
      </Card>
    );
  };

  const ListIsNotOperacao = ({ endereco }) => {
    return (
      <Card
        elevation={1}
        sx={{
          mb: 2,
          p: 2,
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          "&:hover": {
            boxShadow: 3,
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <HomeWorkIcon color="primary" />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {endereco.cidade}
            </Typography>
            <Chip
              label={endereco.ativo ? "Ativo" : "Inativo"}
              size="small"
              color={endereco.ativo ? "success" : "default"}
              variant="outlined"
            />
          </Box>

          <Box sx={{ display: "flex", gap: 1 }}>
            <IconButton
              size="small"
              onClick={handlerEditarEndereco(endereco)}
              sx={{ color: theme.palette.primary.main }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              onClick={desativaAtiva(endereco.id)}
              sx={{
                color: endereco.ativo
                  ? theme.palette.success.main
                  : theme.palette.text.secondary,
              }}
            >
              {endereco.ativo ? (
                <ToggleOnIcon fontSize="small" />
              ) : (
                <ToggleOffIcon fontSize="small" />
              )}
            </IconButton>
          </Box>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <Box component="span" sx={{ fontWeight: 600 }}>
                CEP:{" "}
              </Box>
              {endereco.cep}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <Box component="span" sx={{ fontWeight: 600 }}>
                Endereço:{" "}
              </Box>
              {endereco.logradouro} {endereco.numero && `, ${endereco.numero}`}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <Box component="span" sx={{ fontWeight: 600 }}>
                Bairro:{" "}
              </Box>
              {endereco.bairro}
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <Box component="span" sx={{ fontWeight: 600 }}>
                Estado:{" "}
              </Box>
              {endereco.uf}
            </Typography>
            {endereco.complemento && (
              <Typography variant="body2">
                <Box component="span" sx={{ fontWeight: 600 }}>
                  Complemento:{" "}
                </Box>
                {endereco.complemento}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Card>
    );
  };

  useEffect(() => {
    if (!isSedex && isOperacao && enderecosCliente?.length > 0) {
      let enderecoFiltrado = enderecosCliente.filter(
        (e) => e.idUf == regiaoEntregaSelecionada?.uf?.id
      );
      setEnderecoFiltro(enderecoFiltrado);
    } else setEnderecoFiltro(enderecosCliente);
  }, [enderecosCliente]);

  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <BasicModal
        show={openModal}
        error={textError}
        successMessage={textSuccess}
        close={handlerCloseModal}
        sx={{
          "& .MuiBox-root": {
            borderRadius: 2,
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          <Titulo
            sx={{ mb: 3, fontSize: 24, fontWeight: 600 }}
            label="Cadastro/Edição de endereço"
          />
          <Grid item xs={12}>
            <EnderecoItem
              isEdit={true}
              setTextError={setTextError}
              setTextSuccess={setTextSuccess}
              data={enderecoModal}
              setData={setEnderecoSelected}
            />
          </Grid>
          <Grid item xs={12} mt={2}>
            <ButtonAcaoGrande
              style={{ marginTop: 25 }}
              variant="contained"
              fullWidth
              isLoading={isLoading}
              type="submit"
              Handle={handlerSubmitSalvarEndereco}
            >
              Salvar
            </ButtonAcaoGrande>
          </Grid>
        </Box>
      </BasicModal>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "right",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600 }}></Typography>
        <ButtonCustom
          variant="contained"
          startIcon={<AddLocationIcon />}
          onClick={handlerEditarEndereco(enderecoDefault)}
          sx={{
            borderRadius: 2,
            px: 3,
          }}
        >
          Novo Endereço
        </ButtonCustom>
      </Box>

      {!isLoading && enderecosCliente?.length > 0 ? (
        isOperacao ? (
          enderecoFiltro?.length > 0 &&
          enderecoFiltro.some((e) => e.ativo === true) ? (
            <Box>
              {enderecoFiltro.map((endereco, index) => {
                return (
                  endereco.id > 0 &&
                  endereco.ativo && (
                    <Fragment key={index}>
                      <ListIsOperacao endereco={endereco} />
                    </Fragment>
                  )
                );
              })}
            </Box>
          ) : (
            <Paper
              sx={{
                p: 3,
                textAlign: "center",
                bgcolor: alpha(theme.palette.info.main, 0.1),
                borderRadius: 2,
              }}
            >
              <PersonPinCircleRoundedIcon
                color="info"
                sx={{ fontSize: 48, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Endereço não encontrado
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Você não possui endereço cadastrado para a região de{" "}
                <Box component="span" sx={{ fontWeight: 600 }}>
                  {regiaoEntregaSelecionada?.uf?.descricao}
                </Box>
              </Typography>
            </Paper>
          )
        ) : (
          <Box>
            {enderecosCliente.map((endereco, index) => {
              return (
                endereco.id > 0 && (
                  <Fragment key={index}>
                    <ListIsNotOperacao endereco={endereco} />
                  </Fragment>
                )
              );
            })}
          </Box>
        )
      ) : (
        <Paper
          sx={{
            p: 4,
            textAlign: "center",
            // bgcolor: alpha(theme.palette.primary.main, 0.05),
            borderRadius: 2,
          }}
        >
          <PersonPinCircleRoundedIcon
            color="primary"
            sx={{ fontSize: 48, mb: 2 }}
          />
          <Typography variant="h6" gutterBottom>
            Nenhum endereço encontrado
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Você ainda não cadastrou nenhum endereço.
          </Typography>
          <ButtonCustom
            variant="contained"
            startIcon={<AddLocationIcon />}
            onClick={handlerEditarEndereco(enderecoDefault)}
          >
            Adicionar Primeiro Endereço
          </ButtonCustom>
        </Paper>
      )}
    </Box>
  );
}
